import React from 'react';
import ReactDOM from 'react-dom';
import { ThemeProvider } from '@mui/material/styles';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import 'bootstrap';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import registerServiceWorker from './registerServiceWorker';
import JavascriptTimeAgo from 'javascript-time-ago'

import en from 'javascript-time-ago/locale/en'
import ru from 'javascript-time-ago/locale/ru'
import theme from './theme';
import { store } from './store';

JavascriptTimeAgo.addLocale(en)
JavascriptTimeAgo.addLocale(ru)

ReactDOM.render(
    <Provider store={store}>
        <ThemeProvider theme={theme}>
            <App />
        </ThemeProvider>
    </Provider>
    , document.getElementById('root'));
registerServiceWorker();
